import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
import { withEnvRoot } from '@tportal/common/utils';
import ActivationPage from '@tportal/login/containers/ActivationPage';
import LoginPage from '@tportal/login/containers/LoginPage';
import { AlertProvider } from '@tportal/login/hooks/use_alert';

interface Props {
  logoUrl?: string;
  selfSignupEnabled?: boolean;
  email?: string;
  isHOA: boolean;
  pmInfo: any;
}

export const App = (props: Props) => {
  const {
    logoUrl,
    selfSignupEnabled,
    email,
    isHOA,
    pmInfo
  } = props;

  return (
    <AlertProvider>
      <Switch>
        <Route
          exact
          path={withEnvRoot('/users/sign_in')}
          component={() => (
            <LoginPage
              isHOA={isHOA}
              logoUrl={logoUrl}
              pmInfo={pmInfo}
              selfSignupEnabled={selfSignupEnabled}
            />
          )}
        />
        <Route
          exact
          path={withEnvRoot('/activations/:activationToken')}
          component={() => (
            <ActivationPage
              email={email}
              isHOA={isHOA}
              logoUrl={logoUrl}
              pmInfo={pmInfo}
            />
          )}
        />
      </Switch>
    </AlertProvider>
  );
};

export default observer(App);
